import React from 'react';
import V2Select from '../forms/V2Select';
import V2Input from '../forms/V2Input';
import '../../../v2-theme.css';

/**
 * FilterBar Component
 *
 * Filter controls for dashboards
 * Matches filter bar from HTML files
 *
 * @param {Object} filters - Filter configuration object
 * @param {Object} values - Current filter values
 * @param {function} onChange - Change handler (receives {filterName, value})
 */
const FilterBar = ({
  filters = [],
  values = {},
  onChange,
  className = '',
  ...props
}) => {
  const handleFilterChange = (filterName, value) => {
    if (onChange) {
      onChange({ filterName, value });
    }
  };

  const renderFilter = (filter) => {
    const commonProps = {
      key: filter.name,
      name: filter.name,
      label: filter.label,
      value: values[filter.name] || '',
      onChange: (e) => handleFilterChange(filter.name, e.target.value)
    };

    switch (filter.type) {
      case 'select':
        return (
          <V2Select
            {...commonProps}
            options={filter.options}
            placeholder={filter.placeholder}
          />
        );
      case 'date':
        return (
          <V2Input
            {...commonProps}
            type="date"
            min={filter.min}
            max={filter.max}
          />
        );
      case 'number':
        return (
          <V2Input
            {...commonProps}
            type="number"
            min={filter.min}
            max={filter.max}
            step={filter.step}
          />
        );
      default:
        return (
          <V2Input
            {...commonProps}
            type="text"
            placeholder={filter.placeholder}
          />
        );
    }
  };

  return (
    <div className={`v2-filter-bar ${className}`} {...props}>
      <div className="v2-filter-row">
        {filters.map(renderFilter)}
      </div>
    </div>
  );
};

export default FilterBar;
